import _ from 'lodash';
import isObject from './isObject.js';
import diffObject from './diffObject.js';
import diffArray from './diffArray.js';

export default function diffValue(baseline, objOrArray, options) {
  if (isObject(objOrArray)) {
    return diffObject(baseline, objOrArray, options);
  }
  if (_.isArray(objOrArray)) {
    return diffArray(baseline, objOrArray, options);
  }
  return undefined;
}
